module.exports = __webpack_public_path__ + "static/media/Consulta-Nutricional-Barana.35e3c41d.jpg";